import {Component, OnDestroy, OnInit} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
// removed legacy rxjs-compat operator import
import {PaginationInstance} from "ngx-pagination";
import {UserVerificationService} from "../services/user-verification.service";
import {KeycloakService} from "../services/keycloak.service";
import {ApiEndpoints} from "../services/api-endpoints";

import {StringUtils} from "../services/string-utils";
declare var $: any;

@Component({ standalone: false, 
  selector: 'app-get-all-join-servers',
  templateUrl: './get-all-join-servers.component.html',
})

export class GetAllJoinServersComponent implements OnInit, OnDestroy {

  isAdmin: boolean = false;
  username: string = KeycloakService.username;
  private apiUrl = ApiEndpoints.GET_ALL_JOIN_SERVERS;
  private userUrl = ApiEndpoints.GET_USER;
  list: any[];
  p: number = 1;
  filterSearch: any;
  keywordSearch: any;
  ownerId;
  public ownerFname;
  public ownerLname;
  public ownerEmail;
  public ownerUname;
  public ownerAffiliation;
  public userList: any;


  public visible = false;
  public visibleAnimate = false;

  public show(): void {
    this.visible = true;
    setTimeout(() => this.visibleAnimate = true, 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }

  configPagerGetAllJoinServers: PaginationInstance = {
    id: 'join-servers-list',
    currentPage: 1,
    itemsPerPage: 10,
  };

  constructor(private route: ActivatedRoute,
              private http: HttpClient,
              private router: Router,
              private userVerificationService: UserVerificationService) {
    this.route.params.subscribe(params => {
      this.filterSearch = params['filterSearch'];
      this.keywordSearch = params['keywordSearch'];
      if (this.filterSearch != "Search Type" || this.keywordSearch != null) {
        this.displayHeaderSearch(this.filterSearch, this.keywordSearch);
      }
    });
    this.isAdmin = this.userVerificationService.isAdmin;
    this.getServers();
    this.getData();
    this.displayHeaderSearch(this.filterSearch, this.keywordSearch);
    this.displayHeaderSearch(this.filterSearch, this.keywordSearch);
    this.displayHeaderSearch(this.filterSearch, this.keywordSearch);
  }


  getData() {
    var body: any = {"username": this.username};
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options =  {headers: headers};
    return this.http.post<any>(this.apiUrl, body, options);
  }

  getServers() {
    this.getData().subscribe(list => {
      this.list = this.parseJoinServersList(list);
      this.setActive(this.list);
    })
  }

  parseJoinServersList(list) {
    list.forEach(list => {
      list.joinEUIs = StringUtils.insertSpacesBetweenIds(list.joinEUIs);
    });
    return list;
  }

  getUserDetails(item) {
    this.ownerFname = "";
    this.ownerLname = "";
    this.ownerEmail = "";
    this.ownerUname = "";
    this.ownerAffiliation = "";

    var body: any = {
      "username": item
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options =  {headers: headers};
    this.http.post<any>(this.userUrl, body, options).subscribe(
        data => {
          this.ownerFname = data.firstName;
          this.ownerLname = data.lastName;
          this.ownerEmail = data.email;
          this.ownerUname = data.username;
          this.ownerAffiliation = data.affiliation;
        }
      );

  }

  displayHeaderSearch(filterSearch, keywordSearch) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options =  {headers: headers};
    if (filterSearch != "Search Type" && keywordSearch != "" && filterSearch && keywordSearch) {
      var url = ApiEndpoints.GET_ALL_JOIN_SERVERS;
      if (filterSearch == "joinEui") {
        var body: any = {
          "username": this.username,
          "joinEui": keywordSearch
        };
      }
      if (filterSearch == "name") {
        var body: any = {
          "username": this.username,
          "name": keywordSearch
        };
      }
      this.http.post(url, body, options).subscribe(data => {
            this.list = this.parseJoinServersList(data)
          }
        );
    }
    if (filterSearch != "Search Type" && keywordSearch == "") {
      this.router.navigate(['/all-join']);
    }
  }

  setActive(list){
      var totalStatus = list.length;
      var totalActive = 0;
      var totalError = 0;
      for(let item of list){
        if (item.status == "Active") {
          totalActive = totalActive + 1;
        }
        else {
          totalError = totalError + 1;
        }
      }
      $(".table-filter-search option").eq(0).html("All (" + totalStatus + ")");
      $(".table-filter-search option").eq(1).html("Active (" + totalActive + "/" + totalStatus + ")");
      $(".table-filter-search option").eq(2).html("Disconnected (" + totalError + "/" + totalStatus + ")");

      $('.table-filter-search').selectpicker({
        liveSearch: true,
        maxOptions: 1
      });
  }


  ngOnInit() {

    $(document).on("click", ".table-filter-search  .dropdown-menu .dropdown-item", function () {
      var index = $(this).attr("data-original-index");
      if (index == 0) {
        $("#join-servers-list tbody tr").each(function () {
          $(this).show();
        });
      }
      if (index == 1) {
        $("#join-servers-list tbody tr").each(function () {
          if ($(this).find("td").eq(2).html() == "Active") {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      }
      if (index == 2) {
        $("#join-servers-list tbody tr").each(function () {
          if ($(this).find("td").eq(2).html() != "Active") {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      }
    });
  }

  ngAfterViewInit() {
    $("#menu0").addClass("collapse");
    $("#menu0").removeClass("collapsed");
    $("#menu1").addClass("collapse");
    $("#menu1").removeClass("collapsed");
    $("#menu2").removeClass("collapse");
    $("#menu2").addClass("collapsed");
    $("#menu3").addClass("collapse");
    $("#menu3").removeClass("collapsed");
  }

  ngOnDestroy() {
  }

}
